/* eslint react-hooks/exhaustive-deps: 0 */

import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Elements } from 'react-stripe-elements';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import helpers from 'utils/helpers';
import { Helmet } from 'react-helmet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import InjectedStripeForm from './StripeForm';
import { PaymentFont } from 'components/Styled';

const CheckoutForm = props => {
  const state = {};
  const { t } = useTranslation();
  const prevProps = helpers.usePrevious(props) || {};

  helpers.setState(state, {
    uiLoaded: false
  });

  const authentication = () => {
    if (props.user) {
      helpers.setState(state, {
        uiLoaded: true
      });
    } else if (props.user === false) {
      props.history.push('/login');
    }
  };

  useEffect(() => {
    if (!prevProps.user !== props.user) {
      authentication();
    }
  }, [props.user]);

  useEffect(() => {
    authentication();
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <title>{t('payment.header.title')}</title>
      </Helmet>
      <div
        style={{
          backgroundColor: '#f5f5f5',
          margin: '0 auto',
          width: '100%',
          height: '100%',
          maxWidth: `${process.env.REACT_APP_MAX_WIDTH}px`
        }}>
        <div
          style={{
            padding: '20px 0 70px',
            overflow: 'hidden'
          }}>
          <div
            style={{
              fontSize: '16px',
              padding: '0 15px 15px'
            }}>
            {t('payment.payment_methods')}
          </div>
          {state.uiLoaded ? (
            <Elements
              fonts={[
                {
                  cssSrc:
                    'https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,700&display=swap'
                }
              ]}>
              <InjectedStripeForm />
            </Elements>
          ) : null}
          <div style={{ textAlign: 'center', padding: '20px 0 25px' }}>
            <div style={{ fontSize: '12px', padding: '10px 0' }}>
              {t('payment.payment_by')}
            </div>
            <PaymentFont margin>
              <FontAwesomeIcon icon={['fab', 'cc-stripe']} />
            </PaymentFont>
            <PaymentFont margin>
              <FontAwesomeIcon icon={['fab', 'cc-visa']} />
            </PaymentFont>
            <PaymentFont margin>
              <FontAwesomeIcon icon={['fab', 'cc-mastercard']} />
            </PaymentFont>
            <PaymentFont margin>
              <FontAwesomeIcon icon={['fab', 'cc-amex']} />
            </PaymentFont>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = state => {
  return {
    user: state.auth.user,
    authRequestSuccess: state.auth.authRequestSuccess
  };
};

export default connect(mapStateToProps)(withRouter(CheckoutForm));
